import { render, staticRenderFns } from "./BaseRegister.vue?vue&type=template&id=30891ca0&scoped=true&"
import script from "./BaseRegister.vue?vue&type=script&lang=js&"
export * from "./BaseRegister.vue?vue&type=script&lang=js&"
import style0 from "./BaseRegister.vue?vue&type=style&index=0&id=30891ca0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30891ca0",
  null
  
)

export default component.exports